import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import {
    REPORTS_RANGE_TYPE,
    REPORTS_FIRST_PERIOD,
    REPORTS_SECOND_PERIOD,
    REPORTS_FIRST_DATA,
    REPORTS_SECOND_DATA,
    REPORTS_LOADING,
} from "../constants";

import { generateReducer } from "../../common/helpers";

const initialState = {
    rangeType: "Monthly",
    firstRange: "",
    secondRange: "",
    firstData: null,
    secondData: null,
    reportDate: null,
    loading: false,
};

const setRangeType = (state, rangeType) => ({
    ...state,
    rangeType,
    firstRange: "",
    secondRange: "",
    firstData: null,
    secondData: null,
    reportDate: null,
    loading: false,
});
const setFirstRange = (state, firstRange) => ({ ...state, firstRange });
const setSecondRange = (state, secondRange) => ({ ...state, secondRange });
const setFirstData = (state, firstData) => ({ ...state, firstData, loading: false });
const setSecondData = (state, secondData) => ({
    ...state,
    secondData,
    reportDate: Date.now(),
    loading: false,
});
const setLoading = (state, loading) => ({ ...state, loading });

const reducers = {
    [REPORTS_RANGE_TYPE]: setRangeType,
    [REPORTS_FIRST_PERIOD]: setFirstRange,
    [REPORTS_SECOND_PERIOD]: setSecondRange,
    [REPORTS_FIRST_DATA]: setFirstData,
    [REPORTS_SECOND_DATA]: setSecondData,
    [REPORTS_LOADING]: setLoading,
};

const reports = generateReducer(reducers, initialState);

export default persistReducer(
    {
        key: "reports",
        storage,
        whitelist: ["hideWarning"],
    },
    reports
);
